/** Робота з payload запису журналу обміну: запит (JSON-рядок) і відповідь ERP */

/** Запит зберігається JSON-рядком; невалідний JSON віддаємо як є */
export const parseRequest = (raw: string | null | undefined): unknown => {
    if (!raw) return null
    try {
        return JSON.parse(raw)
    } catch {
        return raw
    }
}

/** Відформатований текст запиту для копіювання чи файлу */
export const formatRequest = (raw: string | null | undefined): string => {
    const parsed = parseRequest(raw)
    return typeof parsed === 'string' ? parsed : JSON.stringify(parsed, null, 2)
}

/** Людський текст відповіді: з JSON беремо error / message / result, інакше сам рядок */
export const parseResponse = (raw: string | null | undefined): string | null => {
    if (!raw) return null
    try {
        const parsed = JSON.parse(raw)
        if (typeof parsed === 'object' && parsed !== null) {
            const value = parsed.error ?? parsed.message ?? parsed.result
            return value === undefined ? JSON.stringify(parsed) : String(value)
        }
        return String(parsed)
    } catch {
        return raw
    }
}

/** Ім'я файлу для завантаження запиту */
export const requestFileName = (record: { uuid?: string; id?: number | string } | null | undefined): string =>
    `erp-exchange-request-${record?.uuid ?? record?.id ?? 'item'}.json`
